import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { BaseQuestionStyleProps } from '../QuestionStyle.types';

const Main = styled.span`
  display: inline-block;
  min-width: 28px;
  border-radius: 16px;
  background-color: ${colorsV2.gray100};
  color: ${colorsV2.white100};
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
`;

interface QuestionStyleElementProps extends BaseQuestionStyleProps {}

export const QuestionStyleElement = (props: QuestionStyleElementProps) => {
  const { attributes, children } = props;

  return (
    <Main {...attributes} className="question-style-element">
      {children}
    </Main>
  );
};
